import { Model } from 'pinia-orm'
import Child from './Child'

export default class ImpactReason extends Model {
  // entity is a required property for all models.
  static entity = 'ImpactReason'

  static fields() {
    return {
      id: this.uid(), // Use uuid for unique identifier
      isIncrease: this.boolean(true),
      description: this.string(''),
      childId: this.attr(null), // Nullable field for childId
      child: this.belongsTo(Child, 'childId'), // Define the relationship
    }
  }

  declare id: string
  declare description: string
  declare isIncrease: boolean
  declare childId: string | null
  declare child: Child | null // Nullable
}
